import Box from '@mui/material/Box'
import * as React from 'react'

import { Divider, useTheme } from '@mui/material'

import { AppContext } from '../../context'
import WTypography from '../whiteTypography'
import { makeGetRequest } from 'utils/api'
import { useSelector } from 'react-redux'
import { deviseCal } from 'utils/helpers'
import { convertToUserDateFormate } from 'utils/helpers'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)
export default function TableCard({ data }) {
  const siteUser = useSelector((store) => store.user)
  const { t } = useTranslation('layout') // LAP-733 (GE022)

  const [fetchTotalBudget, setTotalBudget] = React.useState(0)
  const siteDevise = useSelector((store) => store.devise)

  React.useEffect(() => {
    const fetchData = async () => {
      const { data } = await makeGetRequest('/api/Finance/accounts_total_budget/', {}, true)

      setTotalBudget(data)
    }

    // fetchData()
  }, [])

  let totalAmountBalance = 0
  const theme = useTheme()
  const { dispatchAccountClick } = React.useContext(AppContext)
  return (
    <>
      <Box sx={{ cursor: 'pointer' }} display={'flex'} mb={2} justifyContent={'space-between'}>
        <WTypography component={'span'} variant="h5">
          {/* LAP-733 (GE022) — hardcoded FR replaced by i18n lookup. */}
          {t('finance.fiStatement.accountBalances')}
        </WTypography>
        <WTypography component={'span'} variant="h5">
          {data && data.calculation.length}
        </WTypography>
      </Box>

      {data &&
        data.calculation.map((v, i) => (
          <React.Fragment key={i}>
            <Box
              className="no-drag"
              // key={i}/
              sx={{
                '&:hover': {
                  backgroundColor: '#00001d',
                  cursor: 'pointer',
                  border: '1px solid #00001d',
                },
              }}
              p={1}
              onClick={() => dispatchAccountClick('CLICK', { id: v.id })}
              display={'flex'}
              justifyContent={'space-between'}
              alignContent={'center'}
              textAlign={'left'}
              border={'1px solid #00001d'}
            >
              <Box>
                {/* LAP-733 (GE022) — hardcoded FR replaced by i18n lookup. */}
                <WTypography variant="subtitle1">{t('finance.fiStatement.lastUpdate')}</WTypography>
                <WTypography variant="subtitle1">
                  {v.TypeCompte} {v.Nom}{' '}
                </WTypography>
                <WTypography variant="subtitle1">{v.NumeroCompte}</WTypography>
              </Box>
              <Box
                display={'block'}
                flexDirection={'column'}
                alignContent={'crigh'}
                justifyContent={'space-between'}
                marginLeft={'auto'}
              >
                <WTypography variant="subtitle1">
                  {convertToUserDateFormate(siteUser.user, v.Date)}
                </WTypography>
                <WTypography
                  variant="h6"
                  fontSize="1rem"
                  sx={{ color: v.balance < 0 ? 'red' : 'green' }}
                >
                  {v.balance < 0
                    ? deviseCal(v.balance, siteDevise.devise.to_eur)
                    : '+' + deviseCal(v.balance, siteDevise.devise.to_eur)}
                </WTypography>
              </Box>
              {v.length !== 0 && <Divider sx={{ backgroundColor: 'white', height: '1px' }} />}
            </Box>
          </React.Fragment>
        ))}
      <WTypography variant="h6" sx={{ color: 'white' }}>
        {/* Total:  */}
        {/* {fetchTotalBudget} */}
        {/* € */}
      </WTypography>
      {data && data.calculation === 0 && (
        <WTypography variant="h6" align="center">
          No Data
        </WTypography>
      )}
    </>
  )
}
